/* istanbul ignore file */
import React from 'react';
import LeavesBreadcrumbs from 'domain/people/leave/shared/LeavesBreadcrumbs';
import { useLeaveUrl } from 'domain/people/leave/leaveRouting';
import { useParams } from 'react-router-dom';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const SingleLeavesBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  const { getSingleEntityUrl } = useLeaveUrl();
  const { id } = useParams<{ id: string }>();

  return (
    <LeavesBreadcrumbs>
      <SingleBreadcrumbItem entity={id!} link={getSingleEntityUrl(id)} />
      {children}
    </LeavesBreadcrumbs>
  );
};

export default SingleLeavesBreadcrumbs;
